export enum GraphMode {
  BAR,
  LINE,
}
